"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onGifHover = exports.onGifClick = exports.onGifSeen = void 0;
const js_analytics_1 = require("@giphy/js-analytics");
const js_util_1 = require("@giphy/js-util");
const firePingback = (actionType) => (gif, userId, target, attributes = {}) => {
    if (!gif.analytics_response_payload) {
        return;
    }
    (0, js_analytics_1.pingback)({
        userId,
        actionType,
        attributes: Object.assign({ position: JSON.stringify((0, js_util_1.getClientRect)(target)) }, attributes),
        analyticsResponsePayload: gif.analytics_response_payload,
    });
};
// no target on this one
const onGifSeen = (gif, userId, position, attributes = {}) => {
    if (!gif.analytics_response_payload) {
        return;
    }
    (0, js_analytics_1.pingback)({
        analyticsResponsePayload: gif.analytics_response_payload,
        userId,
        actionType: 'SEEN',
        attributes: Object.assign({ position: JSON.stringify(position) }, attributes),
    });
};
exports.onGifSeen = onGifSeen;
exports.onGifClick = firePingback('CLICK');
exports.onGifHover = firePingback('HOVER');
//# sourceMappingURL=pingback.js.map